export const sortMarketGroupsByKey = (firstGroup, secondGroup) => {
    return firstGroup.order - secondGroup.order;
};
//# sourceMappingURL=sortMarketGroupsByKey.js.map